/**
 * negocioElegido -- el negocio que el usuario eligio en el panel, leido de localStorage.
 *
 * Vive en infrastructure (es almacenamiento del navegador) para que los clientes de API lo lean sin importar un
 * componente de pantalla: hasta el 26-oct tres clientes importaban presentation/components/BusinessSelector.js, que a
 * su vez importa BusinessApiClient (mapa del panel, excepcion 2; SALA-MAQUINAS-RONDA-T1, Ares #35231).
 * Mismo codigo que tenia BusinessSelector, sin cambios; BusinessSelector lo reexporta y sigue siendo quien escribe
 * la eleccion. Lo prueba scripts/check-negocio-elegido.mjs.
 *
 * @module infrastructure/negocioElegido
 */

export const STORAGE_KEY = 'nx_selected_business';
export const STORAGE_NAME_KEY = 'nx_selected_business_name';

// Formato canonico de business_id en Nexo: biz_ (ej biz_01kwg69e... o biz_autoservicio_elmaizal_001), NO un UUID.
const BIZ_ID_RE = /^biz_[a-z0-9_]+$/i;

export function isValidBusinessId(id) {
  return BIZ_ID_RE.test(String(id || ''));
}

export function getSelectedBusiness() {
  return localStorage.getItem(STORAGE_KEY);
}

export function getSelectedBusinessName() {
  return localStorage.getItem(STORAGE_NAME_KEY) || '';
}
